import { WorkflowStatus } from '../../../types/workflow';
import { DbBatchProcessResponse } from '../../../services/module4Service';

/**
 * Maps database response to a standardized status format for UI display
 */
export interface ExtendedAnalysisResponse {
  status: WorkflowStatus | string;
  created_at?: string;
  updated_at?: string;
  started_at?: string;
  completed_at?: string;
  job_id?: string;
  client_id?: string;
  batch_set?: string;
  total_items?: number;
  processed_items?: number;
  record_count?: number;
  error_count?: number;
  // New BatchJob statistics fields
  total_records?: number;
  processed_records?: number;
  error_records?: number;
  progress_percentage?: number;
  batch_job_updated_at?: string;
  success?: boolean;
  message?: string;
  error?: string;
  output_blob?: string;
  workflow_id?: string;
  results?: any;
  output_links?: { 
    categorized_keywords?: string;
    "results.csv"?: string;
  }
}

/**
 * Maps database batch status response to UI-friendly format
 * @param statusData - The database response
 * @param jobId - Job ID from URL
 * @returns Mapped status format for UI components
 */
export function mapDbStatusToExtendedResponse(statusData: DbBatchProcessResponse, jobId?: string): ExtendedAnalysisResponse {
  return {
    workflow_id: statusData.workflowId?.toString() || '',
    job_id: jobId || '',
    client_id: 'db-client',
    batch_set: 'db-batch',
    status: statusData.status as WorkflowStatus,
    created_at: statusData.created_at ? new Date(statusData.created_at).toISOString() : new Date().toISOString(),
    updated_at: statusData.updated_at ? new Date(statusData.updated_at).toISOString() : new Date().toISOString(),
    started_at: statusData.started_at ? new Date(statusData.started_at).toISOString() : undefined,
    completed_at: statusData.completed_at ? new Date(statusData.completed_at).toISOString() : undefined,
    message: statusData.message || statusData.error,
    // Prefer new BatchJob statistics over legacy fields
    total_items: statusData.total_records || statusData.record_count || statusData.totalItems || 0,
    processed_items: statusData.processed_records || statusData.processedItems || 0,
    record_count: statusData.record_count,
    error_count: statusData.error_count,
    // New BatchJob statistics fields
    total_records: statusData.total_records,
    processed_records: statusData.processed_records,
    error_records: statusData.error_records,
    progress_percentage: statusData.progress_percentage,
    batch_job_updated_at: statusData.batch_job_updated_at,
    success: statusData.success,
    output_blob: (statusData as any).output_blob,
    output_links: (statusData as any).output_links
  };
}
